import { createAction } from '@reduxjs/toolkit';

import type { Product, Purchase, PurchaseError, Subscription } from '../../services/iap';
import { Package } from '../types';

// Initialize IAP
export const iapInitRequest = createAction('iap/initRequest');
export const iapInitSuccess = createAction('iap/initSuccess');
export const iapInitFailure = createAction<string>('iap/initFailure');

// Fetch products
export const iapFetchProductsRequest = createAction<string[]>('iap/fetchProductsRequest');
export const iapFetchProductsSuccess = createAction<Product[]>('iap/fetchProductsSuccess');
export const iapFetchProductsFailure = createAction<string>('iap/fetchProductsFailure');

// Fetch subscriptions
export const iapFetchSubscriptionsRequest = createAction<string[]>('iap/fetchSubscriptionsRequest');
export const iapFetchSubscriptionsSuccess = createAction<Subscription[]>(
	'iap/fetchSubscriptionsSuccess',
);
export const iapFetchSubscriptionsFailure = createAction<string>('iap/fetchSubscriptionsFailure');

// Purchase product
export const iapPurchaseRequest = createAction<{
	productId: string;
	pkg: Package;
	isSubscription: boolean;
}>('iap/purchaseRequest');
export const iapPurchaseSuccess = createAction<{
	purchase: Purchase;
	pkg: Package;
}>('iap/purchaseSuccess');
/** The translation key a cancelled purchase is reported with; the shop treats it as a quiet return. */
export const USER_CANCELLED_PURCHASE = 'T_USER_CANCELLED_PURCHASE';

export const iapPurchaseFailure = createAction<string>('iap/purchaseFailure');

// Purchase update (from listener)
export const iapPurchaseUpdate = createAction<Purchase>('iap/purchaseUpdate');
export const iapPurchaseError = createAction<PurchaseError>('iap/purchaseError');

// Verify purchase with backend
export const iapVerifyPurchaseRequest = createAction<{
	purchase: Purchase;
	pkg: Package;
}>('iap/verifyPurchaseRequest');
export const iapVerifyPurchaseSuccess = createAction<{
	purchase: Purchase;
	pkg: Package;
	newBalance?: number;
}>('iap/verifyPurchaseSuccess');
export const iapVerifyPurchaseFailure = createAction<{
	error: string;
	purchase: Purchase;
}>('iap/verifyPurchaseFailure');

// Reset IAP state
export const iapReset = createAction('iap/reset');

// Disconnect IAP
export const iapDisconnect = createAction('iap/disconnect');
